export default "__VITE_ASSET__D2cJED_h__"